import React from 'react';

import { flagStyles } from '../settings';

const SvgCA = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-864px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgCA;
